import React, { useEffect, useState } from "react";
import Heading from "../components/Heading";
import globals from "../globals";
import CustomLink from "../components/CustomLink";
import ModuleWithLoader from "../components/ModuleWithLoader";
import FancySelectAdvanced from "../elements/FancySelect/FancySelectAdvanced";
import { withRouter } from "react-router-dom";
import store from "../store";
import ReactModal from "./ReactModal";
import Button from "../elements/Button";
import Error from "../components/Error";
import DataSource from "../DataSource";

const FlipToFibreBanner = props => {
    const [services, setServices] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [flipPromotion, setFlipPromotion] = useState(false);
    const [flipPromotionSpeed, setFlipPromotionSpeed] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isFlipFailed, setIsFlipFailed] = useState(false);

    useEffect(() => {
        DataSource.getData(
            "/api/getFlipToFibreServices",
            response => {
                setIsLoaded(true);
                setServices(response.data);
                if (response.data.length === 0) { // If services.length === 0, hide f2f banner in My services.
                    props.handleHideFlipToFibreBanner();
                }
                if (response.services.original.length > 0) {
                    setFlipPromotion(
                        response.services.original[0].flipPromotion
                    );
                    setFlipPromotionSpeed(
                        response.services.original[0].flipPromotionSpeed
                    );
                }
            },
            error => {
                setIsLoaded(true);
                setHasError(true);
            }
        );
    }, []);

    const api_url = process.env.MIX_API_URL;
    const postCreateFlipOver = (id, onSuccess, onFailure) => {
        return DataSource.postData(
            `${api_url}v1/broadband/${id}/create-flip-order`,
            {},
            onSuccess,
            onFailure
        );
    };

    const onSubmit = event => {
        event.preventDefault();
        postCreateFlipOver(
            services[0].value,
            response => {
                handleCloseModal(event);
                setIsSuccess(true);
                setIsFlipFailed(false);
            },
            error => {
                setIsFlipFailed(true);
                setIsSuccess(false);
                console.error(error);
            }
        );
    };

    const handleShowModal = event => {
        event.preventDefault();
        setShowModal(true);
    };

    const handleCloseModal = event => {
        event.preventDefault();
        setShowModal(false);
    };

    const handleSelectAddress = serviceId => {
        props.history.push(`/my-services/nbn/${serviceId}/change-plan`);
    };

    const ShowServices = () => {
        if (services.length > 1) {
            return (
                <div className="row mb-4">
                    <div className="col-12 col-lg-6 offset-lg-3">
                        <label className="d-block bold mb-2">
                            Choose your eligible nbn service:
                        </label>
                        <FancySelectAdvanced
                            list={services}
                            setValue={handleSelectAddress}
                            label="Eligible nbn services"
                        />
                    </div>
                </div>
            );
        } else if (services.length === 1) {
            return (
                <React.Fragment>
                    <p className="m-0 mb-4 lh">
                        <span className="bold">Eligible nbn service</span>
                        <br />
                        {services[0].label}
                    </p>
                    <CustomLink
                        to={`/my-services/nbn/${services[0].value}/change-plan`}
                        className="btn btn-custom mb-2"
                    >
                        Upgrade plan now
                    </CustomLink>
                </React.Fragment>
            );
        } else {
            return (
                <p className="m-0 mb-4 lh bold">
                    You have no eligible nbn services.
                </p>
            );
        }
    };

    const flipPromotionAvailableMessage = () => {
        return (
            <div>
                <ReactModal
                    showModal={showModal}
                    handleCloseModal={() => setShowModal(false)}
                    heading="Flip now"
                >
                    <div className="row">
                        <div className="col-12 text-center">
                            <p className="mt-0 mb-4">
                                Please confirm you would like to{" "}
                                <span className="bold">flip now</span>?
                            </p>
                            <div className="d-flex justify-content-center">
                                <Button
                                    title="Confirm"
                                    action={event => onSubmit(event)}
                                    className="mr-3"
                                    color="green"
                                />
                                <Button
                                    title="Cancel"
                                    action={event => handleCloseModal(event)}
                                    color="red"
                                />
                            </div>
                        </div>
                    </div>
                </ReactModal>
                <p>
                    Hi{" "}
                    <span className="bold">
                        {store.getState().auth.fullName},{" "}
                    </span>
                </p>
                <p className="lh">
                    Take your final step towards fast, reliable internet and
                    enjoy boosted speeds of up to{" "}
                    <span className="bold">{flipPromotionSpeed}Mbps</span> on
                    your current{" "}
                    <span className="bold">{props.services[0].planTitle}</span>{" "}
                    service for 3 months. Just click the button below and Flip
                    to Fibre™. <br />
                    <br />
                    Once you accept the offer that’s it. We’ll take care of the
                    rest. We’ll update you on the progress of your connection
                    via SMS. Don’t worry, we’ll never leave you in the dark.
                </p>
                <p className="lh">
                    <span className="bold">Eligible nbn service</span>
                    <br />
                    {services.length > 0 && services[0].label}
                </p>
                {isSuccess && (
                    <div className="form-success mt-3">
                        Thanks for your order. We’ll update you on the progress
                        of your connection via SMS.
                    </div>
                )}
                {isFlipFailed && (
                    <Error errors={{item: "Oops, something went wrong, please try again later."}} />
                )}
                {!isSuccess && (
                    <Button
                        title="Upgrade plan now"
                        action={handleShowModal}
                        className="btn btn-custom mt-3 mb-4"
                    />
                )}
                <br />
                <CustomLink
                    className="underline"
                    to="https://files.exetel.com.au/terms/Exetel_nbn_Flip_to_Fibre_Upgrade_Bonus_Offer_TCs-10052024.pdf"
                >
                    Terms and conditions
                </CustomLink>
            </div>
        );
    };

    return (
        <div className="module">
            <Heading title="Flip to Fibre™ now!" />
            <ModuleWithLoader
                isLoaded={isLoaded}
                hasError={hasError}
                className="p-4"
            >
                <div className="row text-center">
                    <div className="col-12 col-lg-10 offset-lg-1">
                        {flipPromotion ? (
                            flipPromotionAvailableMessage()
                        ) : (
                            <React.Fragment>
                                <h1
                                    className="mt-2 mb-2"
                                    dangerouslySetInnerHTML={{
                                        __html: globals.noWidows(
                                            "Change to a high-speed nbn plan now for a FREE<br />Fibre-to-the-home connection upgrade"
                                        )
                                    }}
                                />
                                <p className="m-0 mb-4 lh">
                                    Great news, your nbn service below can be
                                    upgraded to Fibre-to-the-home from 12 June
                                    2022.
                                    <br />
                                    Change your current plan to a new high-speed
                                    nbn plan and we’ll upgrade your connection
                                    to Fibre-to-the-home for FREE asap after
                                    this date. Enjoy speeds up to 500Mbps.
                                </p>
                                <ShowServices />
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </ModuleWithLoader>
        </div>
    );
};

export default withRouter(FlipToFibreBanner);



// WEBPACK FOOTER //
// ./resources/js/modules/FlipToFibreBanner.js